import React from "react";
import AiBadge from "./AiBadge";

/**
 * Wrapper für Sonner-Toast-Benachrichtigungen, der ein "KI Generiert"-Etikett
 * in der Ecke des kleinen Popups anzeigt (Transparenz gemäß KI-Verordnung (EU) 2024/1689).
 */
export default function ToastWithAiBadge({ children }) {
  return (
    <div className="relative">
      {children}
      <AiBadge className="absolute -top-2 -right-2" />
    </div>
  );
}